'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareSemver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var minimumCssVersion = {
  majorVersion: '1',
  minorVersion: '4',
  patchVersion: '10',
  hash: 'sha256-+EkA61nUkAwyyc9NiD89S9oSMn2BSKookBuSDae4E3c='
};

// using state only to track css being loaded is not enough to support hot-loading
// after first onCssLoad isLoaded state will always be true even across unmount/mounts
var cssLoaded = void 0;

var compareSemver = exports.compareSemver = function compareSemver(a, b) {
  var aValues = [a.majorVersion, a.minorVersion, a.patchVersion];
  var bValues = [b.majorVersion, b.minorVersion, b.patchVersion];
  for (var i = 0; i < 3; i++) {
    if (aValues[i] === bValues[i]) {
      continue; // eslint-disable-line no-continue
    }
    if (aValues[i] < bValues[i]) {
      return -1;
    }
    return 1;
  }
  return 0;
};

var CssLoader = function (_Component) {
  _inherits(CssLoader, _Component);

  function CssLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CssLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CssLoader.__proto__ || Object.getPrototypeOf(CssLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoaded: cssLoaded !== undefined ? cssLoaded : false
    }, _this.onCssLoaded = function () {
      cssLoaded = true;
      _this.setState({ isLoaded: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CssLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // this should be solvable with onLoad and onError directly if helmet will approve:  https://github.com/nfl/react-helmet/pull/299
      window.addEventListener('mcpCssLoaded', this.onCssLoaded);
      window.addEventListener('mcpCssError', this.onCssLoaded);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mcpCssLoaded', this.onCssLoaded);
      window.removeEventListener('mcpCssError', this.onCssLoaded);
    }
  }, {
    key: 'render',
    value: function render() {
      var overrideVersion = this.props.overrideVersion;
      // could use semVer, but this is a simple scenario and mcp css version number are simple

      var version = !overrideVersion || compareSemver(minimumCssVersion, overrideVersion) >= 0 ? minimumCssVersion : overrideVersion;
      var url = 'https://static.ux.cimpress.io/mcp-ux-css/' + version.majorVersion + '.' + version.minorVersion + '/development/' + version.majorVersion + '.' + version.minorVersion + '.' + version.patchVersion + '/css/mcp-ux-css.min.css';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactHelmet2.default,
          null,
          _react2.default.createElement('link', {
            onLoad: 'window.dispatchEvent(new CustomEvent(\'mcpCssLoaded\'))',
            onError: 'window.dispatchEvent(new CustomEvent(\'mcpCssError\'))',
            rel: 'stylesheet',
            href: url,
            charSet: 'utf-8',
            integrity: version.hash,
            crossOrigin: 'anonymous'
          })
        ),
        this.state.isLoaded ? this.props.children : null
      );
    }
  }]);

  return CssLoader;
}(_react.Component);

exports.default = CssLoader;


CssLoader.propTypes = {
  overrideVersion: _propTypes2.default.shape({
    majorVersion: _propTypes2.default.string.isRequired,
    minorVersion: _propTypes2.default.string.isRequired,
    patchVersion: _propTypes2.default.string.isRequired,
    hash: _propTypes2.default.string.isRequired
  }),
  children: _propTypes2.default.node
};